import { Card, Col, Flex, Row } from 'antd'
import dayjs from 'dayjs'

import { GetActivitiesListResponseItem } from 'src/api/requests'
import { Text } from 'src/components'
import { dayMonthYearHourMinutesFormat } from 'src/libs'
import { useLocales } from 'src/locales'

import { useStyles } from './styles'

export const ActivityCard = (data: GetActivitiesListResponseItem) => {
  const { t } = useLocales()
  const { styles } = useStyles()

  return (
    <Card
      className={styles.card}
      bordered={false}
      styles={{
        body: {
          padding: '11px 16px'
        }
      }}
    >
      <Row>
        <Col span={14}>
          <Flex vertical>
            <Text strong>{data?.message}</Text>

            {data?.roleId && (
              <Text className={styles.roleText}>
                {t('common.role')}: {data?.roleName}
              </Text>
            )}
          </Flex>
        </Col>

        <Col span={5}>
          {data?.legalEntityId && (
            <Text className={styles.roleText}>{data?.legalEntityName}</Text>
          )}
        </Col>

        <Col span={5}>
          <Flex
            gap={8}
            align="center"
            justify="flex-end"
            className={styles.timeWrapper}
          >
            <div className={styles.dot} />
            {dayjs
              .utc(data?.createdOn)
              .tz()
              .format(dayMonthYearHourMinutesFormat)}
          </Flex>
        </Col>
      </Row>
    </Card>
  )
}
